import { compose, onlyUpdateForKeys, withHandlers } from "recompose";
import withLifecycle from "@hocs/with-lifecycle";
import { XeroClient } from "services";
import {
  isArray,
  isObject,
  isString,
  get,
  pickBy,
  identity,
  isFunction,
} from "lodash";

const enhance = compose(
  onlyUpdateForKeys([
    "ordering",
    "path",
    "offset",
    "limit",
    "search",
    "refreshToken",
    "url",
    "filters",
  ]),
  withHandlers({
    fetch:
      ({
        url,
        ordering: tmpOrdering,
        offset,
        limit,
        filters: tmpFilters,
        onDataFetched,
        onDataError,
        search,
      }) =>
      () => {
        const order = isString(tmpOrdering)
          ? tmpOrdering
          : tmpOrdering.column
          ? `${tmpOrdering.column}${tmpOrdering.direction === 2 ? " DESC" : ""}`
          : "";

        const page = Math.floor(offset / limit) + 1;

        let params = pickBy({ order, page }, identity);
        params = {...params, pageSize:limit}

        const filters = isFunction(tmpFilters)
          ? tmpFilters({ search })
          : tmpFilters;

        if (isObject(filters)) {
          params = {
            ...params,
            ...filters,
          };
        }

        onDataFetched({ count: 0, loading: true, results: [] });
        if (onDataError) onDataError(null);

        const client = XeroClient();

        client
          .get(url, {
            params,
          })
          .then(({ data }) => {
            if (isArray(data)) {
              onDataFetched({ count: 0, results: data });
            } else {
              onDataFetched(data);
            }
          })
          .catch((err) => {
            if (onDataError) {
              onDataFetched({
                count: 0,
                loading: false,
                error: err,
                results: [],
              });
              onDataError(err);
              return;
            }

            const status = get(err, "response.status");
            if (status && status >= 400 && status < 500) {
              onDataFetched({
                count: 0,
                loading: false,
                error: err,
                results: [],
              });
            } else {
              throw err;
            }
          });
      },
  }),
  withLifecycle({
    onDidMount: ({ fetch }) => {
      fetch();
    },
    onDidUpdate: ({ fetch }) => fetch(),
  })
);

export const XeroTableDataFetch = () => null;

export default enhance(XeroTableDataFetch);
